import { GetGooglePlaceService } from './get-google-place.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AcmicService } from './acmic.service';

declare let google: any;

@Injectable({
  providedIn: 'root'
})
export class ValidateAddressService {

    address:                      any = {};
    private messageSource =    new BehaviorSubject<any>(this.address);
    $address = this.messageSource.asObservable();
  
    constructor(
        private getGooglePlaceService: GetGooglePlaceService,
        private acmicService: AcmicService
    ) {}
  
    updateAddress(address: string) {
      this.messageSource.next(address);
    }

    validateAddress(address: string, googleService, isResidential = false, policyStateCode? :string){       
        
        console.log("Policy State Code In Address Update : " + policyStateCode);

      const addressArray = address.split(','),
          addressInput = googleService.$address.source.value;

        if(addressArray.length===5){
            addressArray.splice(1,1);
        }

      if(addressArray.length!==4){
        console.log("length not 4")
          return false;
      }
      else {
        const stateName = addressInput.stateCode || addressInput.state;
        if(!addressInput){
            console.log("No input")
            return false;  
        } else if (!this.acmicService.isACMIC() && isResidential && policyStateCode === "MA" && address.replace(/\s/g, '').toLowerCase().indexOf('ma,usa') === -1){
            console.log("no mass policy")
            return false;
        } else if (!this.acmicService.isACMIC() && isResidential && policyStateCode === "CA" && address.replace(/\s/g, '').toLowerCase().indexOf('ca,usa') === -1){
            console.log("no california")
            return false;
        } else if (this.acmicService.isACMIC() && isResidential && policyStateCode === "ID" && address.replace(/\s/g, '').toLowerCase().indexOf('id,usa') === -1){
            console.log("no idaho")
            return false;
        } 
        else if (this.acmicService.isACMIC() && isResidential && policyStateCode === "WA" && address.replace(/\s/g, '').toLowerCase().indexOf('wa,usa') === -1){
            console.log("no washington")
            return false;
        } else {
            if(addressInput.zipCode.code=="undefined"){
                console.log("no zip")
                return false;
               
            } else if(
                addressInput.streetName.includes('|') ? addressInput.streetName.split('|')[0].trim().toUpperCase() : addressInput.streetName.split('#')[0].trim().toUpperCase() === addressArray[0].trim().toUpperCase() &&
                addressInput.city.trim().toUpperCase() === addressArray[1].trim().toUpperCase() &&
                stateName.trim().toUpperCase() === addressArray[2].trim().toUpperCase() &&
                'USA' === addressArray[3].trim().toUpperCase() 
            ){
                return true;
            } else if(
                addressInput.streetName.includes('|') ? addressInput.streetName.split('|')[0].trim().toUpperCase() : addressInput.streetName.split('#')[0].trim().toUpperCase() ===  addressArray[0].includes('|') ? addressArray[0].split('|')[0].trim().toUpperCase() : addressArray[0].split('#')[0].trim().toUpperCase() &&
                addressInput.city.trim().toUpperCase() === addressArray[1].trim().toUpperCase() &&
                stateName.trim().toUpperCase() === addressArray[2].trim().toUpperCase() &&
                'USA' === addressArray[3].trim().toUpperCase() 
            ){
                return true;
            }else {
                console.log("General")
                return false;
               
            }
        }
            
        }   
    }

    validateZipCodeStateMatch(zipCode: string, state: string): Observable<boolean>{
        console.log("Address Validation zipCode : ", zipCode + " :: state : ", state)
        return new Observable<boolean>((observer) => {
              const geocoder = new google.maps.Geocoder();
              geocoder.geocode(
                {
                    componentRestrictions: {
                      country: "us",
                      postalCode: zipCode
                    }
                }, (results, status) => {
                    if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
                        console.log("Address Validation result : ", results)
                        const addressComponents = results[0].address_components;
                
                        const foundState = addressComponents.find((component) =>
                            component.types.includes('administrative_area_level_1')
                        );
                        console.log("Address Validation foundState : ", foundState)
                        observer.next(foundState.short_name === state);
                        observer.complete();
                    } else {
                        observer.error(`Geocoding failed: ${status}`);
                    }
                });
            });
    }
}
